import React from 'react';

import { DASH } from 'Components/budget_change_requests/changeRequestFormat';

/** One labelled entry of a card; the text is a React child, with its line breaks kept. */
function Entry({ label, children }) {
    return (
        <div className="tw-border-b tw-border-charcoal-15 tw-py-2.5 first:tw-pt-0 last:tw-border-b-0 last:tw-pb-0">
            <span className="bc-kv__key tw-mb-0.5">{label}</span>
            <div className="tw-whitespace-pre-wrap tw-break-words tw-text-[13px] tw-text-charcoal">{children}</div>
        </div>
    );
}

/** A declaration's text, or "None declared", with whether anything was declared at all. */
function Declaration({ declaration, declaredLabel }) {
    return (
        <>
            {declaration.declared ? declaration.text : $t('None declared')}{' '}
            {/* Inline after the last word, so a long declaration carries its chip on its last line. */}
            <span className={`${declaration.declared ? 'bc-chip bc-chip--amber' : 'bc-chip bc-chip--green'} tw-ms-1 tw-whitespace-nowrap tw-align-middle`}>
                {declaration.declared ? declaredLabel : $t('Nil')}
            </span>
        </>
    );
}

/**
 * How an Expenditure Approval was procured, and what its requester declared. A
 * Direct Commitment carries neither, so the body leaves this out for one.
 */
export default function ProcurementDeclarations({ procurement, declarations }) {
    return (
        <>
            <div>
                <div className="bc-eyebrow">{$t('Procurement')}</div>
                <div className="tw-rounded-[10px] tw-border tw-border-charcoal-15 tw-px-4 tw-py-3">
                    <Entry label={$t('Procurement method')}>{procurement.method || DASH}</Entry>
                    <Entry label={$t('Overview of procurement process')}>{procurement.overview || DASH}</Entry>
                    <Entry label={$t('Under-response explanation')}>{procurement.responses || DASH}</Entry>
                </div>
            </div>

            <div>
                <div className="bc-eyebrow">{$t('Other')}</div>
                <div className="tw-rounded-[10px] tw-border tw-border-charcoal-15 tw-px-4 tw-py-3">
                    <Entry label={$t('Conflicts of interest')}>
                        <Declaration declaration={declarations.conflicts} declaredLabel={$t('Declared')} />
                    </Entry>
                    <Entry label={$t('Risks')}>
                        <Declaration declaration={declarations.risks} declaredLabel={$t('Risk noted')} />
                    </Entry>
                    <Entry label={$t('Other information')}>{declarations.other || DASH}</Entry>
                </div>
            </div>
        </>
    );
}
